/**
 * Median gap between a series of ascending timestamps, or null if too few.
 *
 * ONE implementation, two callers measuring DIFFERENT quantities:
 *   - ProjectService.observedCadenceMs() medians the gaps between live data
 *     ARRIVALS, to decide whether a device has gone quiet.
 *   - GraphComponent medians the gaps between ROW TIMESTAMPS in the loaded
 *     dataset, to scale the waterfall's time axis.
 * They are not interchangeable: a completed cure has row timestamps but no live
 * arrivals, so the arrival measure returns null on exactly the historical
 * projects the axis needs to be right for.
 *
 * MEDIAN, NOT MEAN, and it is load-bearing. Measured spacing on real projects
 * ranges 8.2s to 116.1s around a 14.5s median. A mean is dragged to ~34s by a
 * single long gap, which would inflate an offline threshold (hiding real
 * outages) and stretch a time axis (hiding real truncation). The median ignores
 * the outlier, which is the behaviour both callers want.
 */
export function medianGapMs(times: number[], minSamples = 4): number | null {
  if (!Array.isArray(times) || times.length < minSamples) {
    return null;
  }
  const gaps: number[] = [];
  for (let i = 1; i < times.length; i++) {
    const gap = times[i] - times[i - 1];
    if (Number.isFinite(gap) && gap > 0) {
      gaps.push(gap);
    }
  }
  if (gaps.length === 0) {
    return null;
  }
  gaps.sort((a, b) => a - b);
  const mid = Math.floor(gaps.length / 2);
  return gaps.length % 2
    ? gaps[mid]
    : Math.round((gaps[mid - 1] + gaps[mid]) / 2);
}
